import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { applyMode, initMode } from "@/components/ThemeToggle";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { applyMode("dark"); return initMode; }, []);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return setErr("La nuova password deve avere almeno 8 caratteri");
    if (pw !== pw2) return setErr("Le due password non coincidono");
    setBusy(true); setErr("");
    try {
      const r = await api.post("/auth/reset-password", { token, new_password: pw });
      nav("/login", { replace: true, state: { notice: r.data.message } });
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid place-items-center bg-[#09090B] p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6 fade-up" data-testid="reset-form">
        <div>
          <div className="inline-block bg-white rounded-xl px-4 py-3 mb-6"><img src="/nolium-logo-full.png" alt="NOLIUM" className="h-10 w-auto" /></div>
          <h2 className="text-3xl font-bold text-white">Nuova password</h2>
          <p className="text-sm text-zinc-400 mt-1">Scegli una nuova password di almeno 8 caratteri.</p>
        </div>
        {!token ? <div className="text-sm text-red-300" data-testid="reset-no-token">Link non valido. Richiedi un nuovo link dalla pagina di accesso.</div> : <>
          <div className="space-y-4">
            <div><Label className="text-xs text-zinc-400">Nuova password</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required className="h-11 mt-1.5" data-testid="reset-password-input" /></div>
            <div><Label className="text-xs text-zinc-400">Conferma password</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required className="h-11 mt-1.5" data-testid="reset-password-confirm-input" /></div>
          </div>
          {err && <div className="text-sm text-red-300 bg-red-500/10 border border-red-500/30 rounded-md px-3 py-2" data-testid="reset-error">{err}</div>}
          <Button type="submit" disabled={busy} className="w-full h-11 bg-[#11A9A2] hover:bg-[#0e8f89] text-white" data-testid="reset-submit-button">
            {busy && <Loader2 className="animate-spin mr-2" size={16} />}Salva nuova password
          </Button></>}
        <Link to="/login" className="block text-sm text-[#11A9A2] hover:underline" data-testid="reset-back-login">Torna all'accesso</Link>
      </form>
    </div>
  );
}
